import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { RoleState } from 'modules/role/redux';

export const roleSelector = (state: RootState) => state.role;

export const isRoleStateSelector = createSelector(roleSelector, (state: RoleState) => state);
export const paramsSelector = createSelector(roleSelector, (state: RoleState) => state.params);
export const listRoleSelector = createSelector(roleSelector, (state: RoleState) => state.listRole);
